module.exports = (Promise.resolve(__parcel__require__("./" + "Debugger.worker.77753fbf.0a5236a4.0f3189f6.js"))).then(() => parcelRequire('5rm7U'));